export default __webpack_public_path__ + "static/medium-image-richinstead-1-8f83eb0f87ffb6c825a7c702109eb673.png";